import * as yup from "yup";

export const createUserScheduleFormValidationSchema = yup.object().shape({
  scheduleName: yup
    .string()
    .trim()
    .required("Schedule name is required")
    .typeError("Must be a valid string"),
});

export type CreateUserScheduleFormValuesYup = yup.InferType<
  typeof createUserScheduleFormValidationSchema
>;
export type CreateUserScheduleFormValues = {
  scheduleName: CreateUserScheduleFormValuesYup["scheduleName"];
};
